import {
    initialUsersDirectoryState,
    UsersDirectoryState,
} from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.reducers';
import { AppState } from 'mk2/reducers';

export const getUsersDirectoryState = (state: AppState): UsersDirectoryState =>
    state.containers.users.usersDirectory || initialUsersDirectoryState;
